import styled from "@emotion/styled";
import huggedSVG from "assets/images/hugged-not-rugged.svg";
import sparkleSVG from "assets/images/sparkles.svg";
import { H1, TagLink, TagList } from "atoms";
import { mostExplored } from "features/reviewable/data";

// TODO: turn this into an API call
type TagArrayType = [string, React.ComponentProps<typeof TagLink>["variant"]];
const tags: TagArrayType[] = mostExplored as TagArrayType[];

function MostExplored() {
  return (
    <Aside>
      <HuggedSticker src={huggedSVG} alt="" />
      <SparkleSticker src={sparkleSVG} alt="" />
      <H1>Most Explored Filters</H1>

      <TagListMostExplored justify="center">
        {tags.map(([tag, variant]) => (
          <TagLink key={tag} tag={tag} variant={variant} />
        ))}
      </TagListMostExplored>
    </Aside>
  );
}

const bpDesktop = "@media (min-width: 800px)";

const Aside = styled.aside({
  gridArea: "footer",
  margin: "4rem 2rem",
  position: "relative",
  [bpDesktop]: {
    width: "80%",
    margin: "4rem auto",
  },
  h1: {
    textAlign: "center",
    marginBottom: "2rem",
  },
});

const Sticker = styled.img({
  display: "none",
  position: "absolute",
  top: 0,
  [bpDesktop]: {
    display: "block",
  },
});
const HuggedSticker = styled(Sticker)({
  left: "-10%",
  transform: "rotate(-9deg)",
  width: "12%",
});
const SparkleSticker = styled(Sticker)({
  right: "-12%",
  width: "10%",
});

const TagListMostExplored = styled(TagList)({
  maxWidth: "800px",
  marginLeft: "auto",
  marginRight: "auto",
});

export { MostExplored };
